import { AmountAndCurrency } from "../amountAndCurrency";

export enum SalarySacrificeStatus {
  CREATED = "CREATED",
  ASSIGNED = "ASSIGNED",
  ERRORED = "ERRORED"
}

export interface SalarySacrificeAssignmentMetadata {
  employerId: string;
  employeeId: string;
  employeeAccountId: string;
  planId: string;
  planName: string;
  employeeFullName: string;
}

export interface SalarySacrifice {
  id: string;
  transactionId: string;
  particulars?: string;
  code?: string;
  reference?: string;
  amount: AmountAndCurrency;
  status: SalarySacrificeStatus;
  topUpLedgerId?: string;
  assignmentMetadata?: SalarySacrificeAssignmentMetadata;
  createdAt: Date;
}
